/**
 * «Costo según Twilio» de una campaña: el precio que Twilio informó en cada mensaje contra lo que
 * estimaba nuestra tabla para ESOS mismos mensajes, con la cobertura (Twilio puede tardar horas en
 * completar el precio, o no completarlo: §8 D-2). No cambia ningún cobro.
 */

import type { CostoConciliado } from "../../types.estadisticas";
import { ACLARACION_COSTO_TWILIO, pctConSigno, textoConciliacion } from "../../logic/estadisticas";
import { usd } from "../../logic/formato";
import { num } from "../../../campana-nueva/utils/format";

export function TarjetaCostoTwilio({ costo }: { costo: CostoConciliado }) {
  const hayPrecio = Number(costo?.mensajesConPrecio) > 0;
  return (
    <div className="space-y-3">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
        <div className="rounded-xl bg-slate-50 px-3 py-2.5">
          <p className="text-lg font-semibold text-slate-900">{hayPrecio ? usd(costo.precioTwilioUSD, 4) : "Sin dato"}</p>
          <p className="text-xs text-slate-600">Según Twilio</p>
        </div>
        <div className="rounded-xl bg-slate-50 px-3 py-2.5">
          <p className="text-lg font-semibold text-slate-900">{hayPrecio ? usd(costo.estimadoTablaUSD, 4) : "—"}</p>
          <p className="text-xs text-slate-600">Nuestra tabla, mismos mensajes{hayPrecio && pctConSigno(costo.diferenciaPct) ? ` (${pctConSigno(costo.diferenciaPct)})` : ""}</p>
        </div>
        <div className="rounded-xl bg-slate-50 px-3 py-2.5">
          <p className="text-lg font-semibold text-slate-900">{num(costo?.mensajesConPrecio ?? 0)} de {num(costo?.mensajesTotales ?? 0)}</p>
          <p className="text-xs text-slate-600">Mensajes con precio de Twilio</p>
        </div>
      </div>
      <p className="text-sm text-slate-700">{textoConciliacion(costo)}</p>
      <p className="text-xs text-slate-400 leading-relaxed">{costo?.aclaracion || ACLARACION_COSTO_TWILIO}</p>
    </div>
  );
}

export default TarjetaCostoTwilio;
